
import { defineComponent, PropType } from 'vue'
import { PackageManager, VulnerabilityOccurrenceFixability } from '~/types/types'
import { getPackageManagerIcon } from '~/utils/dependencies'
import { extractRouteParams } from '~/utils/router'

export interface VCSLink {
  type: 'pullRequest' | 'commit'
  url: string
}

export default defineComponent({
  name: 'OccurrenceHeader',
  props: {
    target: {
      type: String,
      default: ''
    },
    packageManager: {
      type: String as PropType<PackageManager>,
      default: ''
    },
    showFixButton: {
      type: Boolean,
      default: true
    },
    vcsLink: {
      type: Object as PropType<VCSLink>,
      default: null
    },
    identifier: {
      type: String,
      required: true
    },
    fixability: {
      type: String as PropType<VulnerabilityOccurrenceFixability>,
      default: VulnerabilityOccurrenceFixability.Unfixable
    }
  },
  computed: {
    prevRoute() {
      const {
        name,
        params: { provider, owner, repo, target }
      } = this.$route
      const defaultRoute = {
        name: 'provider-owner-repo-dependencies-target-vulnerabilities',
        params: {
          provider,
          owner,
          repo,
          target
        }
      }

      return name !== this.$nuxt.context.from?.name
        ? (extractRouteParams(this.$nuxt.context.from) ?? defaultRoute)
        : defaultRoute
    },
    isAutofixable() {
      return this.fixability === VulnerabilityOccurrenceFixability.AutoFixable
    }
  },
  methods: {
    getPackageManagerIcon,
    extractRouteParams
  }
})
